var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4257 6.66797C15.8606 6.66797 17.2366 7.19475 18.2512 8.13243C19.2658 9.07012 19.8358 10.3419 19.8358 11.668V17.5013H16.2291V11.668C16.2291 11.2259 16.0391 10.802 15.7009 10.4895C15.3627 10.1769 14.904 10.0013 14.4257 10.0013C13.9474 10.0013 13.4887 10.1769 13.1505 10.4895C12.8124 10.802 12.6224 11.2259 12.6224 11.668V17.5013H9.01562V11.668C9.01562 10.3419 9.58562 9.07012 10.6002 8.13243C11.6148 7.19475 12.9909 6.66797 14.4257 6.66797V6.66797Z",
    stroke: "#D3D3D3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.80273 7.5H5.40946V17.5H1.80273V7.5Z",
    stroke: "#D3D3D3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6061 5.0013C4.60207 5.0013 5.40946 4.25511 5.40946 3.33464C5.40946 2.41416 4.60207 1.66797 3.6061 1.66797C2.61013 1.66797 1.80273 2.41416 1.80273 3.33464C1.80273 4.25511 2.61013 5.0013 3.6061 5.0013Z",
    stroke: "#D3D3D3",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.95d1ac0ecad0cdd22857ae11bd4ab68f.svg";
export { ForwardRef as ReactComponent };